/**
 * @generated SignedSource<<e0ef17a4383410b110b8d5593bcde2ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationScreenContent_presentation$data = {
  readonly canEdit: boolean | null | undefined;
  readonly description: string | null | undefined;
  readonly presenter: {
    readonly firstName: string;
    readonly lastName: string;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserItem_user" | "UserPrimaryPhotoNew_user">;
  } | null | undefined;
  readonly presenterFirstName: string | null | undefined;
  readonly presenterLastName: string | null | undefined;
  readonly prettyUrl: string;
  readonly title: string;
  readonly videoSourceUrl: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationEvents_presentation" | "PresentationGuilds_presentation" | "PresentationMetadata_presentation" | "PresentationVideoPlayer_presentation">;
  readonly " $fragmentType": "PresentationScreenContent_presentation";
};
export type PresentationScreenContent_presentation$key = {
  readonly " $data"?: PresentationScreenContent_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationScreenContent_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationScreenContent_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slugId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhotoNew_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserItem_user"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationMetadata_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationVideoPlayer_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationEvents_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationGuilds_presentation"
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "dabc78a91c81baffaa6e1310db0f134a";

export default node;
